import React, { useState } from "react";
import { motion } from "framer-motion";

const courses = [
  {
    title: "Intermediate With IIT-JEE & NEET",
    desc: "Best intermediate college in Hyderabad offering integrated coaching for IIT-JEE & NEET with expert faculty, personalized mentorship, and board + entrance preparation under one roof."
  },
  {
    title: "Long-Term and Short-term Courses",
    desc: "Choose from Hyderabad’s most trusted long-term and short-term coaching programs for NEET, IIT-JEE, and EAPCET to suit your career goals and timelines."
  },
  {
    title: "IIT-JEE Long-Term",
    desc: "One-year intensive IIT-JEE long-term coaching in Hyderabad with advanced problem-solving, expert IIT faculty, and regular mock tests for top ranks in JEE Mains & Advanced."
  },
  {
    title: "NEET Long-Term",
    desc: "Hyderabad’s top NEET long-term program with detailed NCERT-based modules, daily tests, and concept-focused mentoring to crack AIIMS & Government MBBS seats."
  },
  {
    title: "EAPCET Long-Term",
    desc: "Target EAMCET success with Rankridge’s long-term EAPCET coaching in Hyderabad, featuring concept clarity, daily practice, and top engineering college admission focus."
  },
  {
    title: "IIT-JEE Short-Term",
    desc: "Rapid revision and crash courses for IIT-JEE aspirants in Hyderabad. Perfect for last-minute preparation with topic-wise tests and time-bound strategy sessions."
  },
  {
    title: "NEET Short-Term",
    desc: "Best NEET short-term coaching in Hyderabad to boost scores with focused revision, subject-wise tests, and exam strategy guidance by NEET experts."
  },
  {
    title: "EAPCET Short-Term",
    desc: "Short-term EAPCET coaching in Hyderabad covering Physics, Chemistry, and Math/Biology concepts with practice tests, rank-predictor tools, and expert faculty guidance."
  },
  {
    title: "BITSAT Coaching",
    desc: "Specialized BITSAT coaching in Hyderabad with speed-based problem-solving, online mock tests, and expert training for admission into BITS Pilani and Hyderabad campuses."
  }
];

const CourseGrid = () => {
  return (
    <div className="bg-gradient-to-b from-white via-blue-50 to-white py-3 px-4 sm:px-6 lg:px-3 sm:py-3">
      <h2 className="text-3xl font-bold text-center text-black mb-10">
        Rankridge Best Courses
      </h2>
      <div className="grid gap-8 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
        {courses.map((course, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            className="bg-white rounded-2xl shadow-md p-6 hover:shadow-xl transition duration-300 border-t-4 border-[#20b2aa]"
          >
            <h3 className="text-xl font-semibold text-[black] mb-2">
              {course.title}
            </h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              {course.desc}
            </p>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default CourseGrid;
